// 08-01-2026


import axios from "axios";

const api = axios.create({
  baseURL: "https://apicrm.zenrealestate.in/api",
  // baseURL: "https://apicrm.zenrealestate.in/api",
});

// Attach token dynamically on every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle unauthorized globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
